import { Invitation } from './../../../shared/models/invitation.model';
import { Injectable } from '@angular/core';
import { ApiHandlerService } from '../../../shared/service/api-handler/api-handler.service';
import { CommonService } from '../../../shared/core.index';
import { catchError, map, Observable, of } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InvitationsService {

  constructor(private commonService: CommonService, private apiHandlerService: ApiHandlerService) { }


  // Invitation's API
  getInvitations(offset: number, limit: number, order_by: string,
    order_type?: string,
    name?: string,
    invitation_date?: string,
    email?: string,
    org_unit?: string,
    contact_name?: string,
    status?: string
  ): Observable<any> {
    const queryParams: any = {};

    if (limit != undefined) {
      queryParams.limit = limit;
    }
    if (offset != undefined) {
      queryParams.offset = offset;
    }
    if (order_by != undefined) {
      queryParams.order_by = order_by;
    }
    if (order_type != undefined) {
      queryParams.order_type = order_type;
    }
    if (name != undefined) {
      queryParams.name = name;
    }
    if (email != undefined) {
      queryParams.email = email;
    }
    if (invitation_date != undefined) {
      queryParams.invitation_date = invitation_date;
    }
    if (org_unit != undefined) {
      queryParams.org_unit = org_unit;
    }
    if (contact_name != undefined) {
      queryParams.contact_name = contact_name;
    }

    return this.apiHandlerService.doGet<any>(`api/vms/invitations`, true, true, queryParams)
  }

  getInvitationById(id: string): Observable<any> {
    return this.apiHandlerService.doGet<any>(`api/vms/invitations/${id}`, true, true);
  }

  getInvitationInfo(id: string): Observable<any> {
    return this.apiHandlerService.doGet<any>(`api/vms/invitations/info/${id}`, true, true);
  }

  resolveShortUrl(code: string): Observable<any> {
    return this.apiHandlerService.doGet<any>(`api/short-url/${code}`, true, true);
  }

  resolveInvitationCode(code: string): Observable<any> {
    return this.apiHandlerService.doGet<any>(`api/vms/invitations/inv/${code}`, true, true);
  }

  verifyInvitationById(id: string): Observable<any> {
    return this.apiHandlerService.doGet<any>(`api/vms/invitations/verify/id?id=${id}`, true, true);
  }

  addInvitation(data: any): Observable<any> {
    return this.apiHandlerService.doPost<any>('api/vms/invitations', data, true, true).pipe(
      map(response => response),
      catchError(error => {
        console.log('Error adding Invitation:', error);
        return of({ error: 'Failed to add Invitation' });
      })
    );
  }


  updateInvitation(id: string, data: any): Observable<any> {
    const endpoint = `api/vms/invitations/${id}`;
    return this.apiHandlerService.doPut<any>(endpoint, data, true, true).pipe(
      map(response => response),
      catchError(error => {
        console.log('Error updating Invitation:', error);
        return of({ error: 'Failed to update Invitation' });
      })
    );
  }


  resendInvitation(id: string, data: any): Observable<any> {
    const endpoint = `api/vms/invitations/resend/${id}`;
    return this.apiHandlerService.doPost<any>(endpoint, data, true, true).pipe(
      map(response => response),
      catchError(error => {
        console.log('Error resending Invitation:', error);
        return of({ error: 'Failed to update Invitation' });
      })
    );
  }

  downloadInvitation(id: string): Observable<Blob> {
    const endpoint = `api/vms/invitations/download/${id}`;
    return this.apiHandlerService.doGetBlob(endpoint, true, true).pipe(
      map(response => response),
      catchError(error => {
        console.log('Error downloading Invitation:', error);
        return of(new Blob([]));
      })
    );
  }

  deleteInvitation(id: string): Observable<any> {
    const endpoint = `api/vms/invitations/${id}`;
    return this.apiHandlerService.doDelete<any>(endpoint, true, true).pipe(
      map(response => response),
      catchError(error => {
        console.log('Error deleting Invitation:', error);
        return of({ error: 'Failed to delete Invitation' });
      })
    );
  }
}
